const BASE_URL = process.env.VUE_APP_API_BASE_URL || ''
let storeInstance = null
let authExpired = false

export function setStore(store) {
  storeInstance = store
}

export function resetAuthExpired() {
  authExpired = false
}

export function getFullUrl(path) {
  if (!path) return ''
  if (path.startsWith('http://') || path.startsWith('https://')) return path
  return BASE_URL + path
}

function getToken() {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    return user.token || ''
  } catch {
    return ''
  }
}

function getLangHeaderValue() {
  const language = localStorage.getItem('language') || 'zh'
  return language === 'en' ? 2 : 1
}

function toFormData(data) {
  const formData = new FormData()
  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, value)
    }
  })
  return formData
}

export async function request(url, options = {}) {
  const token = getToken()
  const isFormData = options.formData === true
  const body = isFormData && options.body ? toFormData(options.body) : options.body

  const headers = {
    ...(!isFormData && { 'Content-Type': 'application/json' }),
    ...(token && { token }),
    lang: getLangHeaderValue(),
    ...options.headers
  }

  const response = await fetch(`${BASE_URL}${url}`, {
    ...options,
    body,
    headers
  })

  const result = await response.json().catch(() => ({}))

  if (!response.ok) {
    // const error = new Error(result.msg || `Request failed: ${response.status}`)
    // error.status = response.status
    // error.data = result
    // throw error
  }

  // 全局拦截 401：登录态失效。标记保持到重新登录成功才重置，
  // 避免支付轮询等高频请求在失效期间反复弹窗和提示
  if (result.code === 401 && !authExpired) {
    authExpired = true
    if (storeInstance) {
      // 直接清除本地登录态，不调用 logout 接口避免死循环
      storeInstance.commit('SET_USER', null)
      storeInstance.dispatch('openLoginModal')
      storeInstance.dispatch('showToast', {
        message: result.msg || '登录状态已过期，请重新登录',
        type: 'warning',
        duration: 4000
      })
    }
  }

  return result
}
